import { keyframes } from 'styled-components';

export const fadeIn = keyframes`
	from {
		opacity: 0;
	}
`;

export const fadeInScale = keyframes`
	from {
		opacity: 0;
		transform: scale(0.9);
	}
`;

export const fadeInSlideUp = keyframes`
	from {
		opacity: 0;
		transform: translateY(10%);
	}
`;

export const fadeInSlideRight = keyframes`
	from {
		opacity: 0;
		transform: translateX(-15%);
	}
`;

export const fadeInSlideLeft = keyframes`
	from {
		opacity: 0;
		transform: translateX(15%);
	}
`;

export const slideIn = keyframes`
	from {
		opacity: 0;
		transform: translateY(150px);
	}
`;
